import { useRef, useState } from 'react'

import { Box, BoxProps } from '@chakra-ui/react'

import { useDebouncedResizeListener } from 'src/lib/hooks/auth/useDebouncedResizer'

const HIDE_LOCK_SWITCH_THRESHOLD = 30

const MagicTopDrawer: React.FC<
  { children: React.ReactNode; Drawer?: React.FC } & BoxProps
> = ({ children, Drawer, ...props }) => {
  const { ref, rect } = useDebouncedResizeListener()
  const lastScrollTop = useRef(0)
  const [marginTop, setMarginTop] = useState(0)

  const scrollHandler = (ev: React.UIEvent<HTMLDivElement>) => {
    const scrollTop = ev.currentTarget.scrollTop
    const drawerHeight = rect?.height
    if (!drawerHeight) return
    if (
      scrollTop > drawerHeight &&
      scrollTop - lastScrollTop.current > HIDE_LOCK_SWITCH_THRESHOLD
    ) {
      setMarginTop(-drawerHeight)
    }
    if (lastScrollTop.current - scrollTop > HIDE_LOCK_SWITCH_THRESHOLD) {
      setMarginTop(0)
    }
    if (
      (scrollTop > lastScrollTop.current && marginTop === -drawerHeight) ||
      (scrollTop < lastScrollTop.current && marginTop === 0)
    ) {
      lastScrollTop.current = scrollTop
    }
  }
  if (!Drawer) return <>{children}</>
  return (
    <Box
      position="relative"
      {...props}
      overflowY="auto"
      overflowX="hidden"
      onScroll={scrollHandler}
    >
      <Box
        ref={ref}
        position="sticky"
        transition="top .2s"
        left={0}
        right={0}
        top={marginTop}
        background="white"
        zIndex="sticky"
      >
        <Drawer />
      </Box>
      {children}
    </Box>
  )
}

export default MagicTopDrawer
